export default __webpack_public_path__ + "static/knox-50c45711c2f421cd82d44671de96ccb9.png";